export const SET_LAWS_PROJECTS_FETCHING = 'SET_LAWS_PROJECTS_FETCHING';
export const SET_LAWS_PROJECTS_FETCHING_ERROR = 'SET_LAWS_PROJECTS_FETCHING_ERROR';
export const SET_LAWS_PROJECTS = 'SET_LAWS_PROJECTS';
export const CLEAN_LAWS_PROJECTS = 'CLEAN_LAWS_PROJECTS';
export const ABORT_PROJECTS_REQUEST = 'ABORT_PROJECTS_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsProjects/actions.js